<div class="d-flex">
    <button type="button" class="context-menu icon-btn fill-valyrianSteel fill-hover-whaleTail" [popover]="popoverTemplate" #actionPopover="bs-popover"
        triggers="manual" container=".cx-one-ui" [outsideClick]="true" containerClass="cxone-popover" (click)="refresh(params); showPopover($event);">
        <svg class="icon-16">
            <use href="../App_Themes/clearview-default/icons/utility/more.svg#more"></use>
        </svg>
        <ng-template #popoverTemplate style="padding: 0;">
            <div class="more-option-popover">
                <ul>
                    <li class="clickable" id="edit-action-btn" (click)="editClick()" >
                        <svg class="icon-20">
                            <use href="../App_Themes/CXone/icons/edit.svg#edit"></use>
                        </svg>
                        <span class="more-option-text" cvLocalizedText langSection="CXOne_Manage_Metrics"
                            langKey="Edit">Edit</span>
                    </li>
                    <li class="clickable" id="duplicate-action-btn" (click)="duplicateClick()" *ngIf="showDuplicateBtn">
                        <svg class="icon-20">
                            <use href="../App_Themes/CXone/icons/cxone-duplicate.svg#cxone-duplicate"></use>
                        </svg>
                        <span class="more-option-text" cvLocalizedText langSection="CXOne_Manage_Metrics"
                            langKey="Duplicate">Duplicate</span>
                    </li>
                    <li class="clickable" id="duplicate-action-btn"  *ngIf="showDuplicateBtn">
                        <svg class="icon-20">
                            <use href="../App_Themes/CXone/icons/project-dashboard.svg#project-dashboard"></use>
                        </svg>
                        <span class="more-option-text" cvLocalizedText langSection="Module"
                            langKey="Project_Header">Project</span>
                    </li>
                    <li class="clickable" id="delete-action-btn" (click)="deleteClick()" 
                        triggers="manual" container="body" placement="left"
                          popoverClass="cxoneConfirmDashboardDeletePopover">
                        <svg class="icon-20">
                            <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
                        </svg>
                        <span class="more-option-text" cvLocalizedText langSection="CXOne_Manage_Metrics"
                            langKey="Delete">Delete</span>
                    </li>
                </ul>
            </div>
        </ng-template>
    </button>
</div>
